import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es un curso grabado o un material de lectura?',
  a: 'Es un manual metodológico digital exhaustivo (E-book de nivel profesional) acompañado de un Kit de herramientas prácticas descargables (PDF listos para imprimir y usar). Está diseñado para ser consultado directamente en tu tablet, computadora o impreso como carpeta clínica de escritorio.'
}, {
  q: '¿Sirve para psicólogos tradicionales de corriente cognitivo-conductual o psicoanálisis?',
  a: 'Sí, totalmente. El primer módulo está diseñado específicamente para crear un puente respetuoso y riguroso. Te da la base epistemológica y científica para sustentar el uso del árbol genealógico y las memorias del cuerpo sin comprometer tu ética profesional ni tu corriente de base.'
}, {
  q: '¿Qué diferencia tiene esto con un libro de Constelaciones Familiares tradicional?',
  a: 'Los libros tradicionales suelen ser abstractos y teóricos. Este material es una guía de aplicación práctica directa en consulta individual (uno a uno). Te da los guiones de voz exactos para hablarle al paciente y las fichas técnicas de diagnóstico que ningún otro libro del mercado incluye.'
}, {
  q: '¿Cómo accedo al material después de realizar el pago?',
  a: 'El acceso es inmediato. Una vez procesado el pago seguro, recibirás un correo electrónico con tus credenciales de acceso directo para descargar los 5 módulos centrales y los 3 súper bonos VIP en formato PDF de alta resolución.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream-100 relative" data-id="element-61">
      <div className="container mx-auto px-6" data-id="element-62">
        <SectionHeading title="PREGUNTAS FRECUENTES" subtitle="Dudas Comunes de Colegas" data-id="element-63" />

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-64">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-gold-500/20 rounded-sm overflow-hidden shadow-sm" data-id="element-65">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none hover:bg-cream-50 transition-colors" data-id="element-66">
                <span className="font-serif font-bold text-lg text-navy pr-8" data-id="element-67">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-68">
                  <ChevronDown className="w-5 h-5 text-gold-500 flex-shrink-0" data-id="element-69" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-70">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-71">
                    <div className="px-6 pb-5 text-navy/70 leading-relaxed border-t border-gray-100 pt-4" data-id="element-72">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};